<template>
    <div class="result__list">
        <template v-if="!this.$store.state.isScreenPhone">
            <div class="result__list-column header">
                <span class="result__list-column-text">{{ getTranslatedText('draw name') }}</span>
                <span class="result__list-column-text center">{{ getTranslatedText('draw Date') }}</span>
                <span class="result__list-column-text center">{{ getTranslatedText('results') }}</span>
            </div>
            <div class="result__item result__list-column" v-for="(v, i) in dataRender" :key="i">
                <div class="result__item-text bold">{{ getTranslatedText(v.draw_name) }}</div>
                <div class="result__item-text center">{{ renderDate(v.draw_date) }}</div>
                <div class="result__item-box">
                    <div :class="['result__item-column', { row: !checkMachineResult(v?.machine_results) }]">
                        <label v-if="checkMachineResult(v?.machine_results)" class="result__item-column-label">{{getTranslatedText('winning numbers')}}:</label>
                        <div class="result__item-box-number" v-for="(itemResults, index) in v.results" :key="index">
                            <span v-if="index > 0" class="result__item-text plus">+</span>
                            <div class="result__item-box__number" v-for="(number, numberIndex) in itemResults" :key="numberIndex">{{ number }}</div>
                        </div>
                    </div>
                    <div v-if="checkMachineResult(v?.machine_results)" class="result__item-column">
                        <label class="result__item-column-label">{{getTranslatedText('machine numbers')}}:</label>
                        <div class="result__item-box-number" v-for="(itemMachine, index) in v.machine_results" :key="index">
                            <span v-if="index > 0" class="result__item-text plus">+</span>
                            <div class="result__item-box__number" v-for="(number, numberIndex) in itemMachine" :key="numberIndex">{{ number }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="result__item" v-for="(v, i) in dataRender" :key="i">
                <div class="result__item-content">
                    <span class="result__item-content-label column-first">
                        {{ getTranslatedText('draw name') }}
                    </span>
                    <span class="result__item-content-value column-last">
                        {{ getTranslatedText(v.draw_name) }}
                    </span>
                </div>
                <div class="result__item-content">
                    <span class="result__item-content-label column-first">
                        {{ getTranslatedText('draw Date') }}
                    </span>
                    <span class="result__item-content-value column-last">
                        {{ renderDate(v.draw_date) }}
                    </span>
                </div>
                <div class="result__item-content">
                    <span class="result__item-content-label column-first">
                        {{ getTranslatedText('results') }}
                    </span>
                    <div class="result__box column-last column">
                        <div :class="['result__item-column', { row: !checkMachineResult(v?.machine_results) }]">
                            <label v-if="checkMachineResult(v?.machine_results)" class="result__item-column-label">{{getTranslatedText('winning numbers')}}:</label>
                            <div class="result__box-number" v-for="(itemResults, index) in v.results" :key="index">
                                <span v-if="index > 0" class="result__item-text plus">+</span>
                                <div class="result__number" v-for="(number, numberIndex) in itemResults" :key="numberIndex">{{ number }}</div>
                            </div>
                        </div>
                        <div v-if="checkMachineResult(v?.machine_results)" class="result__item-column">
                            <label class="result__item-column-label">{{getTranslatedText('machine numbers')}}:</label>
                            <div class="result__box-number" v-for="(itemMachine, index) in v.machine_results" :key="index">
                                <span v-if="index > 0" class="result__item-text plus">+</span>
                                <div class="result__number" v-for="(number, numberIndex) in itemMachine" :key="numberIndex">{{ number }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <ButtonCommon
            v-if="dateSelect !== ''"
            className="w100 result__button-print"
            value="print"
            :isNoHover="true"
            :isLoading="isLoadingButtonPrint"
            @click="onPrintResult"
        />
        <v-pagination v-if="pages > 1" v-model="currentPage" :pages="pages" :range-size="1" @update:modelValue="handlePageChange" />
    </div>
</template>
<script>
import { formatDateUTC, isArrayEmpty } from '@/utils/utils';
import languageMixins from '@/mixins/language-mixins';
import printMixins from '@/mixins/print-mixins';

import VPagination from '@hennge/vue3-pagination';
import '@hennge/vue3-pagination/dist/vue3-pagination.css';

import ButtonCommon from '@/components/common/button/button.vue';

export default {
    mixins: [languageMixins, printMixins],
    components: { VPagination, ButtonCommon},
    props: {
        dataSource: {
            type: Array,
            default: () => [],
        },
        dateSelect: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            dataFull: [],
            dataRender: [],
            currentPage: 1,
            pages: 0,
            isLoadingButtonPrint: false
        };
    },
    created() {
        this.dataFull = [...this.dataSource];
        this.getItemsForPage();
        this.pages = Math.ceil(this.dataFull.length / 10);
    },
    methods: {
        handlePageChange(page) {
            this.currentPage = page;
            this.getItemsForPage();
        },

        getItemsForPage(itemsPerPage = 10) {
            const dataFull = [...this.dataFull];
            const currentPage = this.currentPage;
            const start = (currentPage - 1) * itemsPerPage;
            const end = currentPage * itemsPerPage;
            this.dataRender = dataFull.slice(start, end);
        },

        onPrintResult() {
            this.isLoadingButtonPrint = true
            let dataPrints = this.dataSource.map(x => {
                let game = this.getTranslatedText(x.game)
                let draw_name = this.getTranslatedText(x.draw_name)

                let item = {
                    ...x,
                    game,
                    draw_name
                }

                return item
            })


            this.printResult(dataPrints)
            this.isLoadingButtonPrint = false
        },


        checkMachineResult(MatchResult) {
            return !isArrayEmpty(MatchResult)
        },

        renderDate(date) {
            const dateFormat = formatDateUTC(date);

            let valueDate = `${dateFormat.year}-${dateFormat.month}-${dateFormat.day}`;

            return valueDate;
        },
    },
};
</script>
